import { ALLOW_CREATIVES_VIA_BIDSTREAM_LABEL } from 'components/common/Deal/CreativeBidStream/constants';
import { InputTheme } from 'components/common/types/Input.types';
import ToggleSwitch, { ToggleTheme } from 'lib/ToggleSwitch';
import { Label } from 'lib/Label';

type BidsSubmissionSwitchProps = {
  isChecked: boolean;
  onChange: () => void;
  isDisabled: boolean;
};

export const BidsSubmissionSwitch = ({
  isChecked,
  onChange,
  isDisabled,
}: BidsSubmissionSwitchProps): React.ReactElement => {
  return (
    <div className="flex justify-between items-center h-8">
      <Label theme={InputTheme.FLAT_GRAY} label={ALLOW_CREATIVES_VIA_BIDSTREAM_LABEL} />
      <ToggleSwitch
        onChange={onChange}
        isChecked={isChecked}
        isDisabled={isDisabled}
        dataTestId="bids-submission-toggle"
        theme={ToggleTheme.SMALL_LIGHT}
      />
    </div>
  );
};
